var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center"}},[_c('h1',[_vm._v("Has Any No Permission!")]),_c('div',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.userManager.logout()}}},[_vm._v("Logout")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }